import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import ContactHero from "./sections/ContactHero";
import GetInTouch from "./sections/GetInTouch";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <ContactHero />
      <GetInTouch />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}